export const textStyles = {
  // Links variants
  linkSm: {
    fontSize: "sm",
    fontWeight: "medium",
    lineHeight: "xl",
  },
  linkMd: {
    fontSize: "md",
    fontWeight: "medium",
    lineHeight: "lg",
  },
  linkLg: {
    fontSize: "lg",
    fontWeight: "medium",
    lineHeight: "xl",
  },
  // Badge variants
  badgeSm: {
    fontSize: "xs",
    fontWeight: "medium",
    lineHeight: "xl",
  },
  badgeMd: {
    fontSize: "sm",
    fontWeight: "medium",
    lineHeight: "xl",
  },
  badgeLg: {
    fontSize: "md",
    fontWeight: "medium",
    lineHeight: "xl",
  },
  // Tabs variants
  tabMd: {
    fontSize: "md",
    fontWeight: "medium",
    lineHeight: "md",
    textTransform: "uppercase",
  },
  tabLg: {
    fontSize: "lg",
    fontWeight: "medium",
    lineHeight: "xl",
    textTransform: "uppercase",
  },
  // Alert variants
  alertMd: {
    fontSize: "md",
    fontWeight: "medium",
    lineHeight: "xl",
  },
  alertLg: {
    fontSize: "lg",
    fontWeight: "semi",
    lineHeight: "md",
  },
  // Buttons variants
  buttonXs: {
    fontSize: "sm",
    fontWeight: "normal",
    lineHeight: "lg",
  },
  buttonSm: {
    fontSize: "md",
    fontWeight: "normal",
    lineHeight: "xl",
  },
  buttonMd: {
    fontSize: "lg",
    fontWeight: "medium",
    lineHeight: "xl",
  },
  buttonLg: {
    fontSize: "xl",
    fontWeight: "medium",
    lineHeight: "lg",
  },
  buttonXl: {
    fontSize: "1.5xl",
    fontWeight: "medium",
    lineHeight: "lg",
  },
  button2Xl: {
    fontSize: "2xl",
    fontWeight: "medium",
    lineHeight: "lg",
  },
};
